






























































import GlobalMixin from "@/mixins/global";
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";

export default GlobalMixin.extend({
  components: {},
  props: ["factura", "data", "forceUpdate", "loading", "headers"],

  //props: ["factura"],
  data() {
    return {
      moduleName: "DATATABLE_PAYMENT",
      dialog: false,

      DatatablePayments: [],
      headersRegistroPagos: [],
      // loading: true,

      // DATATABLES
      headerProps: {
        sortByText: "Ordenar por",
      },
      footerProps: {
        itemsPerPageText: "Registros por página",
        itemsPerPageAllText: "Todos",
        pageText: "{0}-{1} de {2}",
        sortByText: "Ordenar por",
      },
      loadingText: "Cargando... Por favor espere",
      noDataText: "Sin datos",
      // REGISTROS
      editedIndex: -1,
      editedItem: {},
      enabledEdit: 0,
      keyFileTempRefuse: "",
      renderComponent: true,
    };
  },
  methods: {
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    convertidor(item: any, ext: any) {
      dataService
        .getFilePayment(item.ComplementoPagoID, ext)
        .then((Response: ResponseData) => {
          const linkSource =
            "data:application/octet-stream;charset=utf-8;base64," +
            Response.data.data;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download =
            item.ComplementoPagoID + "_" + item.serie + item.folio + "." + ext;
          downloadLink.click();
        });
    },
  },
  mounted() {},
});
